var scroll_left = "Scroll left";
var scroll_right = "Scroll right";
var scroll_up = "Scroll up";
var scroll_down = "Scroll down";
var enUS = {
	scroll_left: scroll_left,
	scroll_right: scroll_right,
	scroll_up: scroll_up,
	scroll_down: scroll_down
};

export { enUS as default, scroll_down, scroll_left, scroll_right, scroll_up };
